import React from 'react';
import PropTypes from 'prop-types';
import { Control } from 'react-redux-form';

import TokenInserter from './TokenInserter';
import SAFroala from '../SAFroala/SAFroala';
import Placeholder from '../Placeholder';
import InfoTooltip from 'components/shared/InfoTooltip';

import { ensureKeyed } from 'utils';

import './styles/snippet_editor.scss';
import {FamilyContactTokenWarning} from "./FamilyContactTokenWarning";

const DefaultControl = ({field, model, ...props}) => {
  if (field.hasOwnProperty('options') && field.options.length > 0) {
    return <Control.select model={model} {...props}>
      {
        field.options.map(option => (
          <option key={option.canonicalName} value={option.canonicalName}>
            {option.displayName}
          </option>
        ))
      }
    </Control.select>;
  } else {
    return <Control.text model={model} {...props}/>;
  }
};

class SnippetAttributes extends React.Component {
  static propTypes = {
    fields: PropTypes.array,
    handleSubmit: PropTypes.func,
    htmlAllowDangerousTags: PropTypes.bool,
    prefix: PropTypes.string.isRequired,
    snippet: PropTypes.object,
    showFormatting: PropTypes.bool,
    froalaOptions: PropTypes.object,
    ready: PropTypes.bool,
    combineFamilyContacts: PropTypes.bool,
    communicationType: PropTypes.string
  };

  static defaultProps = {
    fields: [{displayName: 'Name', canonicalName: 'name'}],
    handleSubmit: () => true,
    htmlAllowDangerousTags: false,
    prefix: 'local',
    snippet: {
      tokens: []
    },
    showFormatting: true,
    froalaOptions: {},
    ready: true,
    combineFamilyContacts: false,
    communicationType: 'email'
  };

  constructor(props) {
    super(props);

    this.froala = null;
  }

  /**
   * selectedFields
   *
   * Generates the snippet attribute fields requested by the caller. Fields can be either
   * text fields, select fields (if options are provided), or valid React elements/components
   *
   * @param {Array} fields The list of fields to be displayed
   */
  selectedFields(fields) {
    const {prefix, snippet} = this.props;

    return fields.map((field, i) => {
      if (React.isValidElement(field)) {
        return field;
      } else {
        if (field.hasOwnProperty('condition') && field.condition(snippet) || !field.hasOwnProperty('condition')) {
          const ControlComponent = field.control || DefaultControl;
          return <div className={'control-group'} data-field-name={field.canonicalName}>
            <label className='control-label' htmlFor={`${prefix}.${field.canonicalName}`}>{field.displayName}</label>
            <div className='controls'>
              <div className='row'>
              <span className='col'>
                <ControlComponent field={field} model={`${prefix}.${field.canonicalName}`}/>
              </span>

              {(!!field.tooltip || !!field.optional) && (
                <span className='col snippet-attribute-help'>
                {!!field.tooltip && <InfoTooltip postNbsp placement={'top'}>{field.tooltip}</InfoTooltip>}
                  {!!field.optional && <span className='help-inline'>Optional</span>}
              </span>)}
              </div>
            </div>
          </div>;
        } else {
          return false;
        }
      }
    }).filter((field) => field).map(ensureKeyed());
  }

  render() {
    const {fields, prefix, htmlAllowDangerousTags, showFormatting, froalaOptions, ready, combineFamilyContacts, model, communicationType} = this.props;

    return <div>
      <div className="form-horizontal">
        {this.selectedFields(fields)}
      </div>

      <Control
        model={`${prefix}.tokens`}
        component={TokenInserter}
        controlProps={{
          onInsert: (tokenSelector) => {
            $('.fr-box')[0]['data-froala.editor'].html.insert(`{{${tokenSelector.category}.${tokenSelector.token}}}`, true);
          }
        }}
        mapProps={{
          tokens: (props) => props.modelValue || {}
        }}
      />

      <Placeholder.SAFroala ready={ready} width={660}>
        <Control.text
          model={`${prefix}.body`}
          component={SAFroala}
          mapProps={{
            onModelChange: (props) => (value) => props.onChange(value)
          }}
          htmlAllowDangerousTags={htmlAllowDangerousTags}
          showFormatting={showFormatting}
          froalaOptions={{...froalaOptions, heightMin: 320}}
        />
      </Placeholder.SAFroala>

      {combineFamilyContacts && <FamilyContactTokenWarning communicationType={communicationType} body={model.body}/>}
    </div>;
  }
}

export default SnippetAttributes;
